import templateUrl from "./navigation-failed.component.html";
import "./error-page.less";

export const NavigationFailedComponent = {
    templateUrl,
    bindings: {
        /** A message describing the problem. */
        message: "<?",
        /** The state that the user intended to enter. */
        state: "<?",
        params: "<?"
    },
    controller: class {
        constructor($state) {
            'ngInject';
            this.$state = $state;
        }

        onRetry() {
            this.$state.go(this.state, this.params);
        }
    }
};
